import { TimeOut } from "../configs/base";
import Core from "@sonphat/core";
import AppClass from "./App";

const SP = window.SP;

const $Core = new Core({
    // Cấu hình xác thực truy cập, bắt buộc có nếu muốn tải tải trình xác thực
    Auth: {
        Keycloak: SP["keycloak"] || {
            URL: "https://dangnhap.quanlybenxe.com/auth",
            Realm: "BenXeOnline",
            ClientId: "DieuDo",
        },
    },

    // cấu hình cho api
    Api: {
        BaseURL: SP["Base_Url"] || "https://localhost:5001/",

        Timeout: TimeOut, // (ms), 5s === 5000 ms

        NoExceptionHttpStatus: false,
    },
    Helper: {
        // cấu hình helper
        Format: {
            // cấu hình default format, $Core.Helper.Format.Datetime(new Date(), format)
            DatetimeDefaultFormat: `{yyyy}/{mm}/{dd} {hh}:{ii}:{ss}.{ms}`,
        },
    },
});
const app = new AppClass();

(async function () {
    var $app = await app.Ready();
    if ($app) {
        $app.setup({
            eval: window.eval,
        });
    }
})();

Object.defineProperty($Core, "App", {
    get() {
        return app;
    },
});

function configApi(keyApi, keyConfigApi) {
    Object.defineProperty($Core.Api, keyApi, {
        get() {
            var self = this;
            return function () {
                return self.Make.apply(self, arguments).Config(
                    (c) => (
                        (c.baseURL =
                            SP[keyConfigApi] || "https://localhost:5003/"),
                        c
                    )
                );
            };
        },
    });
}
// configApi("BenXe", "API_QuanLyBenXe");

$Core.Requests = {};

$Core.Requests.Get = async function RequestGet({ ServicesBE, url, dataGet }) {
    try {
        let result = await $Core.Api[ServicesBE || "Make"](url, dataGet).Get();
        return result.Data;
    } catch (ex) {
        if (ex.message == "Network Error")
            throw Error("Không kết nối được đến máy chủ!");
        throw ex;
    }
};

$Core.Requests.Post = async function RequestPost({
    ServicesBE,
    url,
    dataGet,
    dataPost,
}) {
    try {
        let resp = await $Core.Api[ServicesBE](url, dataGet || null).Post(
            dataPost
        );
        return resp.Data;
    } catch (ex) {}
};

export default $Core;
